export class UrlUtility {
    public static getUrlStringWithParams(url: string, paramsObject: any = {}): string {
        let paramsObjectWithDefault = Object.assign({}, paramsObject);
        let urlWithParams: string = url;
        let keys = Object.keys(paramsObjectWithDefault);

        if (keys.length > 0) {
            let addToUrl = function (k, paramsValue) {
                let separator = urlWithParams.indexOf("?") > -1 ? "&" : "?";
                urlWithParams += separator + k + "=" + paramsValue;
            };

            keys.forEach(k => {
                let paramsValue = paramsObjectWithDefault[k];
                if (Array.isArray(paramsValue)) {
                    paramsValue.forEach(function (value) {
                        addToUrl(k, value);
                    });
                } else if (paramsValue != null) {
                    addToUrl(k, paramsValue);
                }
            });
        }

        return urlWithParams;
    }

    public static findUrlParameter(queryParam): string {
        // could be followed by a hash, so split and return the first part
        let value = window.FindURLParameter(queryParam);

        if (value != null) {
            return value.split("#")[0];
        } else {
            return value;
        }
    }

    public static addUrlParameter(name, value) {
        let locationObject = this.getLocationObject();
        let searchQueryPart = locationObject.urlSearchQuery;

        // search for the ? mark, add if not found
        // else add a & as there is probably already a parameter
        if (searchQueryPart.length == 0) {
            searchQueryPart += "?";
        } else {
            searchQueryPart += "&";
        }

        // add parameter
        searchQueryPart += name + "=" + value;

        // update browser history state and form post attribute url
        this.modifyUrl(locationObject, searchQueryPart);
    }

    // case insensitive checking
    public static modifyUrlParameter(name, value) {
        let locationObject = this.getLocationObject();
        let searchQueryPart = locationObject.urlSearchQuery;

        let regex = new RegExp("(" + name + ")([^&]*)", "i");
        searchQueryPart = searchQueryPart.replace(regex, "$1=" + value);

        this.modifyUrl(locationObject, searchQueryPart);
    }

    // case insensitive checking
    public static removeUrlParameter(name) {
        let locationObject = this.getLocationObject();
        let searchQueryPart = locationObject.urlSearchQuery.substring(1).split("&");

        // build new search query
        let newSearchQueryPart = searchQueryPart.filter(function (item) {
            let keyValueSplit = item.split("=");
            return keyValueSplit[0].toLowerCase() != name.toLowerCase();
        }).join("&");

        if (newSearchQueryPart.length > 0) {
            newSearchQueryPart = "?" + newSearchQueryPart;
        }

        return this.modifyUrl(locationObject, newSearchQueryPart);
    }

    private static getLocationObject() {
        const locationObject = window.location;
        return {
            urlOrigin: locationObject.origin,
            urlPathName: locationObject.pathname,
            urlSearchQuery: locationObject.search,
            urlHash: locationObject.hash
        };
    }

    private static modifyUrl(locationObject, searchQueryPart) {
        let jForm = jQuery("form");

        let relativeUrl = locationObject.urlPathName + searchQueryPart + locationObject.urlHash;
        window.history.replaceState(null, window.document.title, relativeUrl);

        let completeUrl = locationObject.urlOrigin + relativeUrl;
        jForm.attr("action", completeUrl);
    }
}